import { createAsyncThunk } from "@reduxjs/toolkit";
import { type CompleteTrainingParams } from "../../../domain/repos/education-repo";
import { type EducationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const completeTraining = createAsyncThunk<
  void,
  CompleteTrainingParams,
  { dispatch: EducationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.COMPLETE_TRAINING, async (params, { extra }) => {
  await extra.educationRepo.completeTraining(params);
});
